import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";
import {cn} from '../cn'

const RecordVoiceOver = ({className, ...props}) => (
  _jsxs('svg', {
    viewBox: "0 0 24 24"   ,
    'aria-hidden': "true",
    focusable: "false",
    ...props,
    className: cn(
      'inline-block h-[1em] w-[1em] shrink-0 select-none fill-current text-[24px]',
      className
    ),
 children: [
    _jsx('circle', { cx: "9", cy: "9", r: "4",} )
    , _jsx('path', { d: "M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4m7.76-9.64-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27M20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14"                      ,} )
  ]})
)

export default RecordVoiceOver
